import AccountBalanceLines
  from '../../../../../components/Sales/Client/Contract/ViewContract/AccountBalanceLines/AccountBalanceLines'
import React, { Component, Fragment } from 'react'
import { Breadcrumb, Card, Col, Collapse, Icon, Popconfirm, Row, Spin, Tabs, Tooltip } from 'antd'
import { get } from 'lodash'
import style from './style.css'
import Overview from '../Form/Overview'
import { strVal } from '../../../../../modules/Utils'
import KeyTerms from '../Form/KeyTerms'
import Payment from '../Form/Payment'
import Rates from '../Form/Rates'
import Communication from '../Form/Communication'
import DocumentsCont from '../../../../../components/Common/Documents/DocumentsCont'
import RefreshButton from '../../../../../elements/Buttons/RefreshButton'
import Status from '../../../../../elements/Status'
import StateSelect from '../../../../../elements/Select/StateSelect'
import CustomSpin from '../../../../../elements/CustomSpin'

const { Panel } = Collapse

const { TabPane } = Tabs

class ViewContract extends Component {
  render() {
    const {
      member,
      supplier,
      fetching,
      contract,
      actions,
      handleOps,
      updateContractState,
      updatingState,
      fetch,
    } = this.props
    const Operations = ({ contract, ...rest }) => {
      const ops = actions.map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleOps(a.key, contract)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
      ops.push(<RefreshButton onClick={fetch} />)
      return (
        <div {...rest}>
          {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
        </div>
      )
    }
    return (
      <CustomSpin spinning={fetching}>
        <Card>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Purchasing</Breadcrumb.Item>
              <Breadcrumb.Item href="#/purchasing/suppliers/list">Vendors List</Breadcrumb.Item>
              <Breadcrumb.Item href={`#/purchasing/suppliers/${supplier._key}/`}>{member.fn}</Breadcrumb.Item>
              <Breadcrumb.Item>{contract.code}</Breadcrumb.Item>
            </Breadcrumb>
            <h3 className={style.title}>
              <h2 className={'icon-text-header'}>
                <Icon
                  type="barcode"
                  style={{
                    marginRight: '5px',
                    color: '#08c',
                  }}
                />
                <Tooltip title="Contract  Code">{strVal(contract, 'code')}</Tooltip>
              </h2>
              <Status value={strVal(contract, 'status')} />

              <Operations style={{ marginTop: '10px' }} contract={contract} status={strVal(contract, 'status')} />
              <Row style={{ marginTop: 10 }}>
                <Col span={2}>Service State:</Col>
                <Col span={4}>
                  <StateSelect value={get(contract, 'state')} onChange={updateContractState} disabled={updatingState} />
                </Col>
                <Col span={1}>
                  <Spin style={{ marginLeft: 10 }} spinning={updatingState} />
                </Col>
              </Row>
            </h3>
            <p className={style.paragraph}>
              <b>{member.fn} </b> Purchasing Contract Details
            </p>
          </Row>
        </Card>
        <Row style={{ paddingTop: '10px' }}>
          <Card style={{ minHeight: '542px' }}>
            <Row style={{ paddingTop: '10px' }}>
              <Tabs defaultActiveKey="dashboard">
                <TabPane
                  tab={
                    <span>
                      <Icon type="info-circle" />
                      Details
                    </span>
                  }
                  key="dashboard">
                  <Collapse bordered={false} defaultActiveKey={['1']}>
                    <Panel header={<h3>Account Overview</h3>} key="1">
                      <Overview member={member} supplier={supplier} contract={contract} readOnly={true} />
                    </Panel>
                    <Panel header={<h3>Key Terms</h3>} key="2">
                      <KeyTerms supplier={supplier} contract={contract} />
                    </Panel>
                    <Panel header={<h3>Payment</h3>} key="4">
                      <Payment supplier={supplier} contract={contract} />
                    </Panel>
                    <Panel header={<h3>Communication</h3>} key="5">
                      <Communication member={member} supplier={supplier} contract={contract} />
                    </Panel>
                    <Panel header={<h3>Rates</h3>} key="6">
                      <Rates supplier={supplier} type={'view'} contract={contract} />
                    </Panel>
                  </Collapse>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                    <Icon type="credit-card"/>
                    Balance Lines
                  </span>
                  }
                  key="#AccountBalanceLines">
                  <AccountBalanceLines contract={contract}/>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="folder-open" />
                      Documents
                    </span>
                  }
                  key="docs">
                  <DocumentsCont owner={contract} />
                </TabPane>
              </Tabs>
            </Row>
          </Card>
        </Row>
      </CustomSpin>
    )
  }
}

export default ViewContract
